import type { App } from 'vue';
import Storage from 'vue-ls';
import type { WebStorage } from 'vue-ls/src/storage/WebStorage';

/**
 * Registers vue-ls for the Vue app.
 * `ls` means Local Storage helper.
 * Use it to persist small UI and session values in the browser.
 */
const options = {
    namespace: '',
    name: 'ls',
    storage: 'local',
};

const { ls } = Storage.useStorage(options);

const VueLsPlugin = {
    install(app: App) {
        const globalProperties = app.config.globalProperties as Record<string, unknown>;

        // `vue-ls` still installs itself through `Vue.prototype`, which triggers the Vue 3
        // compat warning. We only need the storage instance, so wire it in directly.
        globalProperties.$ls = ls;
        app.provide('$ls', ls as WebStorage);
    },
};

export { ls, VueLsPlugin };
export default ls;
